/*
 * Alerts messages
 * The banner generated by this component is based on the alerts
 * sent back from the RSPM server which is likely to contain several
 * strings.
 */

<template>
  <div
    v-if="hasAlerts()"
    class="statusMessage showing noMax error"
  >
    <div class="message alerts">
      <div data-automation="alerts-message-banner">
        RStudio Package Manager Server Alert
        <span
          id="toggleAlerts"
          class="inlineTextAction"
          data-automation="alerts-show-details"
          @click="toggleAlerts"
        >
          {{ toggleMessage }}
        </span>
      </div>
      <span
        v-if="showAlerts"
      >
        <p />
        <ul>
          <li
            v-for="alert in alerts"
            :key="alert"
            data-automation="alerts-text"
          >
            {{ alert }}
          </li>
        </ul>
        <p />
        <p>
          For more information, please refer to the <a
            :href="alertsGuideURL "
            target="_blank"
            data-automation="alerts-admin-guide-link"
          >RStudio Package Manager Admin Guide</a>, or contact an administrator.
        </p>
      </span>
      <div
        id="closeAlertsBanner"
        data-automation="alerts-close-banner"
        class="messageClose"
        @click="closeAlertsBanner"
      />
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import * as types from '../store/mutation-types'
import { serverPath } from '../api/http-common'

export default {
  name: 'Alerts',
  data: function () {
    return {
      showAlerts: false,
    }
  },
  computed: {
    ...mapState({
      alerts: state => state.alerts.alerts,
    }),
    toggleMessage: function () {
      return this.showAlerts ? ' - Hide details' : ' - Show details'
    },
    alertsGuideURL: function () {
      return `${serverPath()}__docs__/admin/alerts/`
    },
  },
  beforeDestroy: function () {
    this.closeAlertsBanner()
  },
  methods: {
    hasAlerts: function () {
      return this.alerts && this.alerts.length
    },
    toggleAlerts: function () {
      this.showAlerts = !this.showAlerts
    },
    closeAlertsBanner: function () {
      this.$store.commit(types.SET_ALERTS, [])
    },
  },
}

</script>
